// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-pages-shortcuts__container{
    background: var(--white-color);
    /* box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32); */
    /* border-radius: 12px; */
    /* margin-bottom: calc(var(--space-and-half) + var(--space-eighth)); */
    margin-top: var(--space);
    border-top: 2px solid var(--new-gray-background-color);
}
.homepage-pages-shortcuts__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    padding-top: var(--space);

}
/* .homepage-pages-shortcuts__list{} */
.homepage-pages-shortcuts__list__page-item{
    display: flex;
    align-items: center;
    /* padding: 9px 10px 9px 24px; */
    padding: 8px;
    /* border-top: 1px solid var(--separator-color);
    border-bottom: 1px solid var(--separator-color); */
    background-color: var(--new-background-color);
    margin-top: 16px;
    border-radius: 4px;
}
.homepage-pages-shortcuts__list__team-item{
    display: flex;
    /* padding: 8px 10px 8px 29px; */
    padding: 0;
    margin-left: 16px;
    margin-top: 14px;
}
.homepage-pages-shortcuts__list__page-item .icon-ball{
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));
    color: var(--white-color);
}

.homepage-pages-shortcuts__list__team-item img{
    width: calc(var(--space-x2-and-half) - var(--space-eighth));
    height: calc(var(--space-x2-and-half) - var(--space-eighth));
    border-radius: 50%;
}

.homepage-pages-shortcuts__list__team-item .icon-ball{
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));
    color: var(--white-color);
}

.homepage-pages-shortcuts__list__page-item img{
    width: calc(var(--space-x2-and-half) - var(--space-eighth));
    height: calc(var(--space-x2-and-half) - var(--space-eighth));
    border-radius: 50%;
}

.homepage-pages-shortcuts__list__page-item__data{
    margin-left: var(--space-half-quarter);
}
.homepage-pages-shortcuts__list__page-item__data-name.baloa-names{
    color: var(--primary-dark-color);
}
.homepage-pages-shortcuts__list__page-item__data-username.baloa-username{
    color: var(--basic-gray-color);
}
.homepage-pages-shortcuts__add-link{
    padding-left: var(--space-and-half);
    padding-top: calc(var(--space) + var(--space-quarter));
    padding-bottom: calc(var(--space) + var(--space-quarter));
}
.homepage-pages-shortcuts__add-link.baloa-names{
    color: var(--new-green-color);
    cursor: pointer;
}
.homepage-pages-shortcuts__add-link .icon-plus{
    font-size: var(--space);
    color: var(--basic-gray-color);
    cursor: pointer;
}
.homepage-pages-shortcuts__separator{
    border-top: 1px solid var(--separator-color);
}
.homepage-pages-shortcuts__menu-link{
    padding-top: calc(var(--space) - var(--space-eighth));
    padding-bottom: calc(var(--space) - var(--space-eighth));
}
.homepage-pages-shortcuts__menu-link.baloa-hyperlink-2{
    text-align: center;
    color: var(--new-green-color);    
    cursor: pointer;
}

.homepage-pages-shortcuts__list__page-item__data__admin{
    display: flex;
    align-items: center;
    padding: 3px 6px;
    background: #3078B3;
    border-radius: 4px;
    text-align: center;
    margin-left: auto;
    height: -webkit-fill-available;
}

.homepage-pages-shortcuts__list__page-item__data__admin.baloa-username {
    color: var(--white-color);
    font-weight: var(--font-medium);
}

.homepage-pages-shortcuts__list__team-item .icon-trophy{
    font-size: 19px;
    color: var(--basic-gray-color);
    align-self: center;
    padding-right: 12px;
}

.homepage-pages-shortcuts__list__team-item .icon-team-2-64{
    font-size: 19px;
    color: var(--basic-gray-color);
    align-self: center;
    padding-right: 12px;
}

.homepage-pages-shortcuts__list__page-item__data-tags{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: 11px;
    line-height: 13px;
    padding-top: 2px;
    display: flex;
}

.homepage-pages-shortcuts__list__page-item__data-tag{
    background: var(--new-gray-background-color);
    border-radius: 25px;
    padding: 2px 6px;
    margin-right: 4px;
    color: var(--primary-dark-color);
}

.homepage-pages-shortcuts__list__page-item__data-tag__green{
    background: var(--new-green-color);
    border-radius: 25px;
    padding: 2px 6px;
    margin-right: 4px;
    color: var(--white-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .homepage-pages-shortcuts__container {
        margin: 10px 15px;
    }

    .homepage-pages-shortcuts__list__team-item img{
        width: 24px;
        height: 24px;
    }
    .homepage-pages-shortcuts__list__team-item {
        align-items: center;
        padding: 0 8px;
        margin-left: 0;
    }    
    .homepage-pages-shortcuts__list__team-item .icon-ball {
        font-size: 16px;        
        padding: 4px;
        height: unset;        
    }
    .homepage-pages-shortcuts__list__team-item .icon-trophy {
        font-size: 14px;
    }
    .homepage-pages-shortcuts__list__page-item__data-tags {
        font-size: 9px;
    }
    .homepage-pages-shortcuts__list__page-item .icon-ball {
        font-size: 16px;        
        padding: 4px;
        height: 24px;
    }
    .homepage-pages-shortcuts__list__page-item {        
        padding: 8px 6px;
        border-radius: 6px;
    }
    .homepage-pages-shortcuts__list__page-item__data__admin {
        font-size: 9px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-page-shortcuts/HomePagePagesShortcutsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,mEAAmE;IACnE,yBAAyB;IACzB,sEAAsE;IACtE,wBAAwB;IACxB,sDAAsD;AAC1D;AACA;IACI,qCAAqC;IACrC,yBAAyB;;AAE7B;AACA,sCAAsC;AACtC;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ;sDACkD;IAClD,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;;AAEA;IACI,2DAA2D;IAC3D,4DAA4D;IAC5D,kBAAkB;AACtB;;AAEA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;;AAEA;IACI,2DAA2D;IAC3D,4DAA4D;IAC5D,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,mCAAmC;IACnC,sDAAsD;IACtD,yDAAyD;AAC7D;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,qDAAqD;IACrD,wDAAwD;AAC5D;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,cAAc;QACd,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".homepage-pages-shortcuts__container{\n    background: var(--white-color);\n    /* box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32); */\n    /* border-radius: 12px; */\n    /* margin-bottom: calc(var(--space-and-half) + var(--space-eighth)); */\n    margin-top: var(--space);\n    border-top: 2px solid var(--new-gray-background-color);\n}\n.homepage-pages-shortcuts__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    padding-top: var(--space);\n\n}\n/* .homepage-pages-shortcuts__list{} */\n.homepage-pages-shortcuts__list__page-item{\n    display: flex;\n    align-items: center;\n    /* padding: 9px 10px 9px 24px; */\n    padding: 8px;\n    /* border-top: 1px solid var(--separator-color);\n    border-bottom: 1px solid var(--separator-color); */\n    background-color: var(--new-background-color);\n    margin-top: 16px;\n    border-radius: 4px;\n}\n.homepage-pages-shortcuts__list__team-item{\n    display: flex;\n    /* padding: 8px 10px 8px 29px; */\n    padding: 0;\n    margin-left: 16px;\n    margin-top: 14px;\n}\n.homepage-pages-shortcuts__list__page-item .icon-ball{\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));\n    color: var(--white-color);\n}\n\n.homepage-pages-shortcuts__list__team-item img{\n    width: calc(var(--space-x2-and-half) - var(--space-eighth));\n    height: calc(var(--space-x2-and-half) - var(--space-eighth));\n    border-radius: 50%;\n}\n\n.homepage-pages-shortcuts__list__team-item .icon-ball{\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));\n    color: var(--white-color);\n}\n\n.homepage-pages-shortcuts__list__page-item img{\n    width: calc(var(--space-x2-and-half) - var(--space-eighth));\n    height: calc(var(--space-x2-and-half) - var(--space-eighth));\n    border-radius: 50%;\n}\n\n.homepage-pages-shortcuts__list__page-item__data{\n    margin-left: var(--space-half-quarter);\n}\n.homepage-pages-shortcuts__list__page-item__data-name.baloa-names{\n    color: var(--primary-dark-color);\n}\n.homepage-pages-shortcuts__list__page-item__data-username.baloa-username{\n    color: var(--basic-gray-color);\n}\n.homepage-pages-shortcuts__add-link{\n    padding-left: var(--space-and-half);\n    padding-top: calc(var(--space) + var(--space-quarter));\n    padding-bottom: calc(var(--space) + var(--space-quarter));\n}\n.homepage-pages-shortcuts__add-link.baloa-names{\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n.homepage-pages-shortcuts__add-link .icon-plus{\n    font-size: var(--space);\n    color: var(--basic-gray-color);\n    cursor: pointer;\n}\n.homepage-pages-shortcuts__separator{\n    border-top: 1px solid var(--separator-color);\n}\n.homepage-pages-shortcuts__menu-link{\n    padding-top: calc(var(--space) - var(--space-eighth));\n    padding-bottom: calc(var(--space) - var(--space-eighth));\n}\n.homepage-pages-shortcuts__menu-link.baloa-hyperlink-2{\n    text-align: center;\n    color: var(--new-green-color);    \n    cursor: pointer;\n}\n\n.homepage-pages-shortcuts__list__page-item__data__admin{\n    display: flex;\n    align-items: center;\n    padding: 3px 6px;\n    background: #3078B3;\n    border-radius: 4px;\n    text-align: center;\n    margin-left: auto;\n    height: -webkit-fill-available;\n}\n\n.homepage-pages-shortcuts__list__page-item__data__admin.baloa-username {\n    color: var(--white-color);\n    font-weight: var(--font-medium);\n}\n\n.homepage-pages-shortcuts__list__team-item .icon-trophy{\n    font-size: 19px;\n    color: var(--basic-gray-color);\n    align-self: center;\n    padding-right: 12px;\n}\n\n.homepage-pages-shortcuts__list__team-item .icon-team-2-64{\n    font-size: 19px;\n    color: var(--basic-gray-color);\n    align-self: center;\n    padding-right: 12px;\n}\n\n.homepage-pages-shortcuts__list__page-item__data-tags{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: 11px;\n    line-height: 13px;\n    padding-top: 2px;\n    display: flex;\n}\n\n.homepage-pages-shortcuts__list__page-item__data-tag{\n    background: var(--new-gray-background-color);\n    border-radius: 25px;\n    padding: 2px 6px;\n    margin-right: 4px;\n    color: var(--primary-dark-color);\n}\n\n.homepage-pages-shortcuts__list__page-item__data-tag__green{\n    background: var(--new-green-color);\n    border-radius: 25px;\n    padding: 2px 6px;\n    margin-right: 4px;\n    color: var(--white-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .homepage-pages-shortcuts__container {\n        margin: 10px 15px;\n    }\n\n    .homepage-pages-shortcuts__list__team-item img{\n        width: 24px;\n        height: 24px;\n    }\n    .homepage-pages-shortcuts__list__team-item {\n        align-items: center;\n        padding: 0 8px;\n        margin-left: 0;\n    }    \n    .homepage-pages-shortcuts__list__team-item .icon-ball {\n        font-size: 16px;        \n        padding: 4px;\n        height: unset;        \n    }\n    .homepage-pages-shortcuts__list__team-item .icon-trophy {\n        font-size: 14px;\n    }\n    .homepage-pages-shortcuts__list__page-item__data-tags {\n        font-size: 9px;\n    }\n    .homepage-pages-shortcuts__list__page-item .icon-ball {\n        font-size: 16px;        \n        padding: 4px;\n        height: 24px;\n    }\n    .homepage-pages-shortcuts__list__page-item {        \n        padding: 8px 6px;\n        border-radius: 6px;\n    }\n    .homepage-pages-shortcuts__list__page-item__data__admin {\n        font-size: 9px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
